import axios from 'axios';

import { ROUTE } from 'common/const';

import authCookie from './authCookie';
import jwtCookie from './jwtCookie';

// A 401 means the backend has rejected the token (idle timeout, absolute
// expiration, or the server losing its "is this token still active" state
// on a restart) - none of which the frontend otherwise notices, since
// isAuthenticated is derived purely from cookie presence. Send the user
// back to login instead of leaving every screen stuck on a stale request.
const setupSessionExpiredInterceptor = () => {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const isOnLoginPage = window.location.pathname.startsWith(ROUTE.LOGIN);

      if (error?.response?.status === 401 && !isOnLoginPage) {
        jwtCookie.remove();
        authCookie.remove();
        window.location.assign(ROUTE.LOGIN);
      }

      return Promise.reject(error);
    },
  );
};

export default setupSessionExpiredInterceptor;
